import { render } from "./syslog.vue?vue&type=template&id=050f7de0&scoped=true"
import script from "./syslog.vue?vue&type=script&lang=js"
export * from "./syslog.vue?vue&type=script&lang=js"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050f7de0"]])

export default __exports__